export default __webpack_public_path__ + "static/puzzle-2207e1ad90ef250630aff83040ae4e0b.svg";